import React, { Fragment, useEffect, useState } from "react";
import SuperCounselorChart from "../../superCounselor/SuperCounselorChart";
import GetStudentService from "../../../services/SchoolIT/GetStudentService";
import CustomLoader from "../../customLoader/CustomLoader";
import AppHeader from "../../../Layout/AppHeader";
import AppSidebar from "../../../Layout/AppSidebar";
import swal from "sweetalert";
import "../../StudentProfile/StudentProfile.scss";
import "../../superCounselor/DownloadSummary.css";
import Dropdown from "../../../assets/images/dropdown/dropdown.png";
import "./StudentStatistics.css";

const StudentStatistics = () => {
  const [user] = useState(
    localStorage.getItem("user") && JSON.parse(localStorage.getItem("user"))
  );
  const [loading, setLoading] = useState(false);
  const [differentGoalData, setDifferentGoalData] = useState();
  const [selectedGoal, setSelectedGoal] = useState();
  const [selectedGoalId, setSelectedGoalId] = useState();
  const [studentStatisticsData, setStudentStatisticsData] = useState();
  const [graphData, setGraphData] = useState();

  const getDetails = () => {
    let obj = {
      student_id: user?.id,
      parent_id: "null",
      role: user?.role,
      school_id: user?.school_id,
      device_type: "web",
      mobile_os: "null",
      app_version: "null",
    };
    GetStudentService.getDetails(obj).then(() => {}).catch(() => {});
  };

  const getDifferentGoal = () => {
    setLoading(true);
    GetStudentService.getDifferentGoal(user?.school_id)
      .then((data) => {
        const goals = data?.data?.data;
        setDifferentGoalData(goals);
        if (goals && goals.length > 0) {
          setSelectedGoal(goals[0]?.goal);
          setSelectedGoalId(goals[0]?.id);
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        swal({
          title: "Oops!!",
          text: "Something went wrong!! Please try again later.",
          icon: "warning",
          dangerMode: true,
          buttons: {
            cancel: true,
          },
          closeOnClickOutside: true,
        });
      });
  };

  const getStudentStatisticsData = () => {
    GetStudentService.getStudentStatisticsData(user?.school_id)
      .then((data) => {
        setStudentStatisticsData(data.data);
      })
      .catch(() => {});
  };

  const handleGoalChange = (e) => {
    const selectedGoalValue = e.target.value;
    const selectedGoalItem = differentGoalData?.find(
      (item) => item.goal === selectedGoalValue
    );
    setSelectedGoal(selectedGoalValue);
    setSelectedGoalId(selectedGoalItem?.id || "");
  };

  useEffect(() => {
    getDetails();
    getDifferentGoal();
    getStudentStatisticsData();
  }, []);

  useEffect(() => {
    if (studentStatisticsData && selectedGoal) {
      const data = studentStatisticsData?.goal_data?.filter(
        (item) => item?.goal_name === selectedGoal
      );
      if (!data || data.length === 0) {
        setGraphData(undefined);
        return;
      }
      setGraphData({
        active_students: studentStatisticsData?.active_students,
        goal_data: data,
        green_stu_count:
          (data[0]?.Freshman?.[1] || 0) +
          (data[0]?.Seniors?.[1] || 0) +
          (data[0]?.Sophmores?.[1] || 0) +
          (data[0]?.Juniors?.[1] || 0),
        total_students: studentStatisticsData?.total_students,
      });
    }
  }, [selectedGoal, studentStatisticsData]);

  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="app-main__inner student-profile-info-main student-stats-page">
            <div className="profile-main">
              <div className="student-stats-inner">
                {loading ? (
                  <CustomLoader />
                ) : (
                  <div>
                    <div className="student-stats-goal-field">
                      <label className="labelBold" htmlFor="school-it-goal-select">
                        Select Goal
                      </label>
                      <div className="student-stats-select-relative">
                        <select
                          id="school-it-goal-select"
                          className="select student-stats-select"
                          value={selectedGoal || ""}
                          onChange={handleGoalChange}
                        >
                          <option value="" disabled>
                            Select Goal
                          </option>
                          {differentGoalData?.map((item, index) => (
                            <option key={item?.id || index} value={item?.goal}>
                              {item?.goal}
                            </option>
                          ))}
                        </select>
                        <div className="student-stats-dropdown-icon">
                          <img src={Dropdown} alt="" />
                        </div>
                      </div>
                    </div>

                    {differentGoalData?.length > 0 ? (
                      <SuperCounselorChart
                        studentStatisticsData={graphData}
                        selectedGoal={selectedGoal}
                        goalId={selectedGoalId}
                      />
                    ) : (
                      <div className="student-stats-empty">
                        No statistics available yet
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default StudentStatistics;
